'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

var GenericRibbonHeaderCategory = function (_Component) {
  _inherits(GenericRibbonHeaderCategory, _Component);

  function GenericRibbonHeaderCategory(props) {
    _classCallCheck(this, GenericRibbonHeaderCategory);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      category: props.category,

      onEnter: props.onEnter,
      onLeave: props.onLeave,
      onClick: props.onClick
    };
    return _this;
  }

  GenericRibbonHeaderCategory.prototype.componentDidMount = function componentDidMount() {};

  GenericRibbonHeaderCategory.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return true;
  };

  GenericRibbonHeaderCategory.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {};

  GenericRibbonHeaderCategory.prototype.render = function render() {
    var _this2 = this;

    // console.log("Category: ", this.state.category);
    return React.createElement(
      'div',
      { className: 'ontology-ribbon__category' },
      this.state.category.groups.map(function (group, index) {
        return React.createElement(
          'div',
          { className: 'ontology-ribbon__category__block', key: index },
          React.createElement(
            'div',
            { className: 'ontology-ribbon__block__title',
              style: _this2.labelStyle(group),
              title: group.description ? group.label + ' (' + group.id + ')\n\n' + group.description : null
            },
            group.label
          ),
          React.createElement('div', { className: 'ontology-ribbon__block__tile--empty',
            style: _this2.itemStyle(group) })
        );
      })
    );
  };

  GenericRibbonHeaderCategory.prototype.labelStyle = function labelStyle(group) {
    var labelStyle = {};
    if (group.type == "All") {
      labelStyle['fontWeight'] = 'bold';
    } else if (group.type == "Other") {
      labelStyle['fontWeight'] = 'bold';
    }
    return labelStyle;
  };

  GenericRibbonHeaderCategory.prototype.itemStyle = function itemStyle(group) {
    var itemStyle = {};
    if (group.type == "All") {
      itemStyle['marginRight'] = '2px';
    } else if (group.type == "Other") {
      itemStyle['marginLeft'] = '2px';
    }
    return itemStyle;
  };

  return GenericRibbonHeaderCategory;
}(Component);

GenericRibbonHeaderCategory.propTypes = process.env.NODE_ENV !== "production" ? {
  category: PropTypes.object.isRequired,

  onEnter: PropTypes.func,
  onLeave: PropTypes.func,
  onClick: PropTypes.func
} : {};

GenericRibbonHeaderCategory.defaultProps = {};

export default GenericRibbonHeaderCategory;